/**
 * @generated SignedSource<<081f010e883095e0eda1f168c4002510>>
 * @relayHash 52223df2e84924b8d9ee72b2050d9732
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 52223df2e84924b8d9ee72b2050d9732

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Data",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Center",
        "kind": "LinkedField",
        "name": "managementCenters",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectCGQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectCGQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "52223df2e84924b8d9ee72b2050d9732",
    "metadata": {},
    "name": "SelectCGQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "3de70c9e7bddc92282160ce501e47195";

export default node;
